import { AxiosRequestHeaders } from 'axios';
import { locales } from '@/lang/locales';

/**
 * It returns an object with a key of 'Accept-Language' and a value of the language passed in
 * @param {string} lang - string = locales.EN
 * @returns An object with a key of 'Accept-Language' and a value of the lang parameter.
 */
export default function getLangHeaders(lang: string = locales.EN): AxiosRequestHeaders {
  return {
    'Accept-Language': lang.toUpperCase(),
  };
}
